module.exports = __webpack_public_path__ + "static/media/aFichier 5.142bd8ed.svg";